import { RouteRecordRaw } from 'vue-router';
import { requireAuth, setDayjsTimezone } from '@/common/router/authGuard';
import { ROLE_PERMISSION_KEY } from '@/common/define/rolePermission.define';
import { extractAccessibleRoutes } from '@/common/auth/auth.utils';
import BaseViewport from '@/common/components/templates/baseViewport/BaseViewport.vue';
import { VIEWPORT_TYPE } from '@/common/components/templates/baseViewport/baseViewport.define';
import { VIEW_MODE } from '@/common/define/common.define';

const PREFIX = 'kubernetes_';

const kubernetesAnalysisMenu: RouteRecordRaw[] = [
  {
    path: '/kubernetes/',
    name: 'Kubernetes',
    component: BaseViewport,
    beforeEnter: [requireAuth, setDayjsTimezone],
    meta: {
      rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_KUBERNETES_ANALYSIS,
      invisibleViewMode: [VIEW_MODE.INTERMAX],
      viewport: VIEWPORT_TYPE.PA_HEADER_TIME,
    },
    children: [
      {
        path: 'kubernetes-event',
        name: `${PREFIX}Kubernetes Event`,
        component: () =>
          import('@/kubernetesAnalysis/views/kubernetesEvent/KubernetesEventView.vue'),
      },
      {
        path: 'kubernetes-history',
        name: `${PREFIX}Kubernetes History`,
        component: () =>
          import('@/kubernetesAnalysis/views/KubernetesHistoryManagement/KubernetesHistoryManagementView.vue'),
      },
      {
        path: 'trend-analysis',
        name: `${PREFIX}Trend Analysis`,
        component: () => import('@/kubernetesAnalysis/views/trendAnalysis/TrendAnalysisView.vue'),
      },
      {
        path: 'job-summary',
        name: `${PREFIX}Job Summary`,
        component: () => import('@/kubernetesAnalysis/views/jobSummary/JobSummaryView.vue'),
      },
      {
        path: 'resource-exception',
        name: `${PREFIX}Resource Exception`,
        component: () =>
          import('@/kubernetesAnalysis/views/resourceException/ResourceExceptionView.vue'),
      },
    ],
  },
];

const getKubernetesAnalysisMenu = () => {
  const filterMenu = extractAccessibleRoutes(kubernetesAnalysisMenu);

  return [...filterMenu];
};
export { kubernetesAnalysisMenu, getKubernetesAnalysisMenu };
